// https://guides.rubyonrails.org/action_cable_overview.html#connect-consumer
import { createConsumer } from '@rails/actioncable'

export default createConsumer('/admin/websocket')
